export default "__VITE_ASSET__Bam60Rjq__"